/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeParameterForm } from '../../AttributeParameterForm'
import '../../../style-common-dialog.scss'

export const AttributeParameterDialogCreate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  actionCreateDispatch,
  parameters
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.parameters.create.scenario')
    : currentProject
    ? t('attributes.parameters.create.project')
    : t('attributes.parameters.create.global')

  /**
   * Action received from the Parameter Form.
   * @see AttributeParameterForm
   *
   * @param {object} newParameter New parameter attribute object to create.
   * @param {string} newParameterId here it's null.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newParameter, newParameterId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeParameterDialogCreate.onDispatchAction()', {
      newParameter,
      newParameterId
    })

    dispatch(actionCreateDispatch(newParameter, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'AttributeParameterDialogCreate.onDispatchAction().dispatch(actionCreateDispatch(...)).then()',
          {
            res
          }
        )

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(
          LoggerTypes.WARN,
          'AttributeParameterDialogCreate.onDispatchAction().dispatch(actionCreateDispatch(...)).catch()',
          {
            res
          }
        )

        checkErrorResponse(res, enqueueSnackbar, t)

        const _data = res?.response?.data || null
        if (_data && (_data?.fields || _data?.error)) {
          let _error = _data?.fields || {}
          if (_data?.error) {
            _error.generic = _data.error
          }
          setErrors(_error)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeParameterDialogCreate.render()', {
    currentProject,
    currentScenario
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeParameterForm
        title={title}
        setOpenDialog={setOpenDialog}
        dispatchAction={onDispatchAction}
        parameters={parameters}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeParameterDialogCreate.displayName = 'AttributeParameterDialogCreate'

AttributeParameterDialogCreate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionCreateDispatch: PropTypes.func.isRequired,
  parameters: PropTypes.arrayOf(PropTypes.object)
}

AttributeParameterDialogCreate.defaultProps = {
  openDialog: false,
  setOpenDialog: () => {},
  actionCreateDispatch: () => {},
  currentProject: null,
  currentScenario: null,
  parameters: []
}
